import React, { memo, useEffect, useState, useMemo } from 'react';
import { View, Text, TextInput, ScrollView, useWindowDimensions, ActivityIndicator } from 'react-native';
import CustomPressable from '../../components/customPressable/customPressable';
import { ImageComp } from '../../components/Image/Image';
import { MINUS, PLUS } from '../../assets';
import CustomDropDown from '../../components/customDropdown/customDropdown';
import { useDispatch, useSelector } from 'react-redux';
import Slider from '@react-native-community/slider';
import { useTranslation } from 'react-i18next';
import { useCssStyle } from '../../customHook/getCssStyle';
import { getCleanUrl } from '../../utils/Helper';
import CustomFlatList from '../../components/customFlatList';
import { COLORS } from '../../style';
import { setRenderFlashMessage } from '../../Redux/Actions/appConfigAction';
import { CustomTextInput } from '../../components/customTextInput';
import { HCOMMERCE } from '../../config/Constant';
import { sendAnalytics } from '../../Redux/Actions/analyticsAction';
import RenderHTML from 'react-native-render-html';
import { getToastPricing } from '../../Redux/Actions/hcommerceAction';

const MyOrders = memo((props) => {

    let now = 'Now';
    const { storeData, configs, cartItem, handleAddToCart, handleRemoveFromCart, handleGoBack, handlePlaceOrder } = props;

    const { t } = useTranslation();
    const getStyles = useCssStyle();
    const dispatch = useDispatch();
    const { width } = useWindowDimensions();

    const { isLoggedIn, loggedInRoomNumber } = useSelector(state => state.appConfigSlice)
    const { currentGuestDetails } = useSelector(state => state.guestDetailsSlice)
    const serverTime = useSelector(state => state.serverDateTimeSlice?.serverTimeDataObj?.time)

    const { currencyDetails } = useSelector(state => state.deviceConfigSlice);
    const currencyCode = currencyDetails.code;
    const precisionLength = currencyDetails.precisionLength || 2;
    const [pricingState, setPricingState] = useState({
        isLoading: false,
        hasError: false,
        errorMessage: ''
    });

    const customWidgetTitleStyle = useMemo(() => {
        const style = getStyles(['list_itemContainer_textContainer_title', 'hcommerce_orderdetails_itemContainer_textContainer_title', {lineHeight: 20}]);
        return Array.isArray(style) ? Object.assign({}, ...style) : style || {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const [storeDetails, setStoreDetails] = useState({
        guestCountOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
        orderTimeList: [],
        taxEnabled: false,
        taxValue: 0,
        serviceChargeEnabled: false,
        serviceCharge: 0,
        showGratitudeSlider: false,
        gratitudeMin: 0,
        gratitudeMax: 100,
        gratitudeDefault: 0,
        showDeliveryCharges: false,
        deliveryCharges: 0
    })

    const [orderDetails, setOrderDetails] = useState({
        selectedTime: now,
        guestCount: '1',
        specialInstructions: '',
        email: "",
        selectedLocation: '',

        totalCartItemValue: 0,
        deliveryChargeValue: 0,
        subTotalAmountValue: 0,
        gratitudePercentValue: 0,
        gratitudeAmountValue: 0,
        taxAmountValue: 0,
        serviceChargeAmountValue: 0,
        totalAmountValue: 0
    });

    const setOrderTimeList = () => {
        let orderTime = [];

        if(!configs?.deliveryTimeConfiguration){
            let nextHour;
    
            if (serverTime.hours === 23) {
                nextHour = 0;
            } else {
                nextHour = serverTime.hours + 1;
            }
            if (serverTime.minutes + 7 > 45) {
                orderTime = [
                    `${nextHour < 10 ? `0${nextHour}` : nextHour}:00`,
                    `${nextHour < 10 ? `0${nextHour}` : nextHour}:15`,
                    `${nextHour < 10 ? `0${nextHour}` : nextHour}:30`,
                    `${nextHour < 10 ? `0${nextHour}` : nextHour}:45`
                ]
            } else if (serverTime.minutes + 7 > 30) {
                orderTime = [
                    `${serverTime.hours < 10 ? `0${serverTime.hours}` : serverTime.hours}:45`,
                    `${nextHour < 10 ? `0${nextHour}` : nextHour}:00`,
                    `${nextHour < 10 ? `0${nextHour}` : nextHour}:15`,
                    `${nextHour < 10 ? `0${nextHour}` : nextHour}:30`
                ]
            } else if (serverTime.minutes + 7 > 15) {
                orderTime = [
                    `${serverTime.hours < 10 ? `0${serverTime.hours}` : serverTime.hours}:30`,
                    `${serverTime.hours < 10 ? `0${serverTime.hours}` : serverTime.hours}:45`,
                    `${nextHour < 10 ? `0${nextHour}` : nextHour}:00`,
                    `${nextHour < 10 ? `0${nextHour}` : nextHour}:15`
                ]
            } else {
                orderTime = [
                    `${serverTime.hours < 10 ? `0${serverTime.hours}` : serverTime.hours}:15`,
                    `${serverTime.hours < 10 ? `0${serverTime.hours}` : serverTime.hours}:30`,
                    `${serverTime.hours < 10 ? `0${serverTime.hours}` : serverTime.hours}:45`,
                    `${nextHour < 10 ? `0${nextHour}` : nextHour}:00`
                ]
            }
            orderTime.splice(0, 0, now);
        } else {
            orderTime = configs?.deliveryTimeConfiguration?.split(",");
        }

        handleStoreDetails({ "orderTimeList": orderTime })
        handleOrderDetails({ "selectedTime": orderTime[0]?.toString() })
    }

    const getRoundOfValue = (value = 0) => {
        return +((Math.round((+value + Number.EPSILON) * 100) / 100).toFixed(precisionLength));
    };

    const handleStoreDetails = (updates) => {
        setStoreDetails((prev) => ({
            ...prev,
            ...updates,
        }));
    };

    const handleOrderDetails = (updates) => {
        setOrderDetails((prev) => ({
            ...prev,
            ...updates,
        }));
    };




    const proceedPlaceOrder = () => {

        if (!isLoggedIn && !orderDetails.email) {
            dispatch(setRenderFlashMessage(true, { type: "danger", message: "Please provide your email" }));
            return;
        }

        if (!orderDetails.selectedLocation) {
            dispatch(setRenderFlashMessage(true, { type: "danger", message: "Please select location" }));
            return;
        }


        const orderItemList = cartItem.map((item) => ({
            storeItemId: item.itemInfo.id,
            quantity: item.quantity,
            pricePerItem: item.itemInfo.itemPrice,
            guestComment: item.itemInfo.cookingInstructions || "",
            addOns: item.addOns.map(({ id, price, quantity, addOnGroupId }) => ({ itemAddonId: id, itemPrice: price, quantity: quantity, addOnGroupId })),
        }));

        const orderPayload = {
            guestEmail: orderDetails.email,
            gratitudeTipValue: orderDetails.gratitudeAmountValue,
            guestComment: orderDetails.specialInstructions,
            guestCount: orderDetails.guestCount,
            orderDeliveryAt: orderDetails.selectedLocation,
            orderDeliveryTime: orderDetails.selectedTime == now ? `${String(serverTime.hours).padStart(2, '0')}:${String(serverTime.minutes).padStart(2, '0')}` : orderDetails.selectedTime,
            orderItemsList: orderItemList
        }

        handlePlaceOrder(orderPayload);
    }




    const selectRoom = (selectedLocation) => {
        handleOrderDetails({ "selectedLocation": selectedLocation.locationNumber });

        let showGratitudeSlider = selectedLocation.gratitudeEnabled && selectedLocation.gratitudeMax > 0;
        handleStoreDetails({
            deliveryCharges: selectedLocation.deliveryCharges,
            showGratitudeSlider: showGratitudeSlider,
            gratitudeDefault: +selectedLocation.gratitudeDefault,
            gratitudeMin: selectedLocation.gratitudeMin,
            gratitudeMax: selectedLocation.gratitudeMax,
        });

        handleGratitudeSliderValue(+selectedLocation.gratitudeDefault)
    }

    const handleGratitudeSliderValue = (gratitudePercent) => {

        handleOrderDetails({
            gratitudePercentValue: getRoundOfValue(gratitudePercent),
        });
    }

    const calculateCharges = () => {

        // Calculate total cart item value
        let totalCartItemValue = cartItem.reduce((sum, item) => sum + +item.totalPrice, 0);
        totalCartItemValue = getRoundOfValue(totalCartItemValue);

        let deliveryChargeValue = storeDetails.deliveryCharges.toString().endsWith("%") ? totalCartItemValue * parseFloat(storeDetails.deliveryCharges) / 100 : storeDetails.deliveryCharges;
        deliveryChargeValue = getRoundOfValue(deliveryChargeValue);

        let subTotalAmountValue = getRoundOfValue(totalCartItemValue);

        let taxAmountValue = storeDetails.taxEnabled ? storeDetails.taxValue * subTotalAmountValue / 100 : 0;
        taxAmountValue = getRoundOfValue(taxAmountValue);

        let serviceChargeAmountValue = storeDetails.serviceChargeEnabled ? storeDetails.serviceCharge * subTotalAmountValue / 100 : 0;
        serviceChargeAmountValue = getRoundOfValue(serviceChargeAmountValue);


        let gratitudeAmountValue = storeDetails.showGratitudeSlider ? +orderDetails.gratitudePercentValue * +subTotalAmountValue / 100 : 0;
        gratitudeAmountValue = getRoundOfValue(gratitudeAmountValue);


        let totalAmountValue = deliveryChargeValue + subTotalAmountValue + taxAmountValue + serviceChargeAmountValue + gratitudeAmountValue;
        totalAmountValue = getRoundOfValue(totalAmountValue);


        handleOrderDetails({
            totalCartItemValue: totalCartItemValue,
            deliveryChargeValue: deliveryChargeValue,
            subTotalAmountValue: subTotalAmountValue,
            taxAmountValue: taxAmountValue,
            serviceChargeAmountValue: serviceChargeAmountValue,
            totalAmountValue: totalAmountValue,
            gratitudeAmountValue: gratitudeAmountValue
        })

        handleStoreDetails({
            showDeliveryCharges: deliveryChargeValue > 0,
        })
    }

    const fetchToastPricing = async () => {
        if (cartItem.length === 0) {
            setPricingState({ isLoading: false, hasError: false, errorMessage: '' });
            return;
        }

        setPricingState({ isLoading: true, hasError: false, errorMessage: '' });

        const orderItemList = cartItem.map((item) => ({
            storeItemId: item.itemInfo.id,
            quantity: item.quantity,
            pricePerItem: item.itemInfo.itemPrice,
            addOns: item.addOns.map(({ id, price, quantity, addOnGroupId }) => ({
                itemAddonId: id,
                itemPrice: price,
                quantity: quantity,
                addOnGroupId
            })),
        }));

        const payload = {
            reservationNumber: isLoggedIn ? currentGuestDetails?.reservationNumber || "" : "",
            roomNo: loggedInRoomNumber || "",
            orderItems: orderItemList
        };

        const callback = (status, data) => {
            if (status && data) {
                // Success - Update charges from Toast API response
                const toastCharges = {
                    totalCartItemValue: data.subTotalAmount || 0,
                    deliveryChargeValue: data.deliveryAmount || 0,
                    subTotalAmountValue: data.subTotalAmount || 0,
                    taxAmountValue: data.taxAmount || 0,
                    serviceChargeAmountValue: data.appliedServiceCharges?.reduce((sum, charge) =>
                        sum + (charge.chargeAmount || 0), 0) || 0,
                    totalAmountValue: data.totalAmount || 0,
                    appliedServiceCharges: data.appliedServiceCharges || []
                };

                handleOrderDetails(toastCharges);
                setPricingState({ isLoading: false, hasError: false, errorMessage: '' });
            } else {

                dispatch(setRenderFlashMessage(true, {
                    type: "danger",
                    message: data || "Failed to fetch pricing. Please try again."
                }));

                setPricingState({
                    isLoading: false,
                    hasError: true,
                    errorMessage: data || "Failed to fetch pricing"
                });
            }
        };

        await getToastPricing(payload, callback);
    };

    useEffect(() => {
        setOrderTimeList();

        handleStoreDetails({
            taxEnabled: configs.taxValue > 0,
            taxValue: configs.taxValue || 0,
            serviceChargeEnabled: configs.serviceCharge > 0,
            serviceCharge: configs.serviceCharge || 0
        })

        let roomFound = false;
        if (configs.deliveryLocations?.length > 0) {
            configs.deliveryLocations.map((location) => {
                if (location.locationNumber == loggedInRoomNumber && !location.mapLocation) {
                    selectRoom(location)
                    roomFound = true
                }
            })
        }

        if (!roomFound && !configs.displayAllDeliveryLocations) {
            selectRoom({
                "locationNumber": loggedInRoomNumber,
                "gratitudeEnabled": true,
                "gratitudeDefault": parseInt(configs.defaultGratitudePercent || 0),
                "gratitudeMax": 100,
                "gratitudeMin": 0,
                "deliveryCharges": 0
            })
        }


        dispatch(sendAnalytics(HCOMMERCE, "PLACE ORDER", { storeName: props.storeName, element: "widget", storeSku: props.currentWidget.storeSku, widgetSessionId: props.hcommerceSessionToken }))

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    useEffect(() => {
        if (storeData.isPricingViaToast) {
            // Only fetch pricing if required fields are present
            if (!orderDetails.selectedLocation) {
                setPricingState({ isLoading: false, hasError: false, errorMessage: '' });
                return;
            }

            // Set loading state before API call
            setPricingState({ isLoading: true, hasError: false, errorMessage: '' });

            // Debounce pricing fetch to avoid too many API calls
            const timeoutId = setTimeout(() => {
                fetchToastPricing();
            }, 300);

            return () => clearTimeout(timeoutId);
        } else {
            calculateCharges();
        }

        // calculateCharges();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cartItem, storeDetails.taxValue, storeDetails.serviceCharge, storeDetails.deliveryCharges, orderDetails.selectedLocation, orderDetails.gratitudePercentValue])


    const renderOrderDetailsList = (cartItemInfo, index) => {

        const imageUri = cartItemInfo.itemInfo.storeItemImages?.find(image => image.imageType === "LARGE")?.imagePath || cartItemInfo.itemInfo.storeItemImages?.[0]?.imagePath;
        const isDisabled = storeData.isPricingViaToast && pricingState.isLoading;

        return (
            <View style={getStyles(['list_itemContainer', 'hcommerce_orderdetails_itemContainer'])} id='list_itemContainer hcommerce_orderdetails_itemContainer'>

                <View style={getStyles(['list_itemContainer_image', 'hcommerce_orderdetails_itemContainer_image'])} id='list_itemContainer_image hcommerce_orderdetails_itemContainer_image'>
                    {imageUri &&
                        <ImageComp
                            source={getCleanUrl(imageUri)}
                            style={getStyles(["list_itemContainer_image_img", "hcommerce_orderdetails_itemContainer_image_img", { width: "100%", height: "100%" }])}
                            id='list_itemContainer_image_img hcommerce_orderdetails_itemContainer_image_img'
                        />
                    }
                </View>

                <View style={getStyles(['list_itemContainer_textContainer', 'hcommerce_orderdetails_itemContainer_textContainer'])} id='list_itemContainer_textContainer hcommerce_orderdetails_itemContainer_textContainer'>
                    <RenderHTML
                        contentWidth={width}
                        baseStyle={customWidgetTitleStyle}
                        source={{ html: cartItemInfo.itemInfo.itemName}}
                        systemFonts={[customWidgetTitleStyle.fontFamily]}
                        id='list_itemContainer_textContainer_title hcommerce_orderdetails_itemContainer_textContainer_title'
                        defaultTextProps={{
                            numberOfLines: 1
                        }}
                    />
                    {cartItemInfo.addOns.length > 0 && <Text style={getStyles(['list_itemContainer_textContainer_subtitle', 'hcommerce_orderdetails_itemContainer_textContainer_subtitle'])} numberOfLines={1} ellipsizeMode="tail" id='list_itemContainer_textContainer_subtitle hcommerce_orderdetails_itemContainer_textContainer_subtitle'>{cartItemInfo.addOns.map((addOnItem) => addOnItem.name).join(", ")}</Text>}


                    <View style={getStyles(['list_itemContainer_textContainer_tertiaryContainer', 'hcommerce_orderdetails_itemContainer_textContainer_tertiaryContainer'])} id='list_itemContainer_textContainer_tertiaryContainer hcommerce_orderdetails_itemContainer_textContainer_tertiaryContainer'>

                        <Text style={getStyles(['list_itemContainer_textContainer_title', 'hcommerce_orderdetails_itemContainer_textContainer_title'])} id='list_itemContainer_textContainer_title hcommerce_orderdetails_itemContainer_textContainer_title'>{currencyCode + cartItemInfo.totalPrice}</Text>


                    </View>
                </View>
                <View style={getStyles(['additem_controls'])} id='additem_controls hcommerce_orderdetails_additem_controls'>
                    <CustomPressable onPress={() => !isDisabled && handleRemoveFromCart(cartItemInfo.itemInfo, index)} style={getStyles(['additem_controls_sub_container'])} id='additem_controls_sub_container'>
                        <ImageComp source={MINUS} style={getStyles(['additem_controls_sub_container_img'])} id='additem_controls_sub_container_img'/>
                    </CustomPressable>
                    <Text style={getStyles(['additem_controls_qty_text'])} id='additem_controls_qty_text'>{cartItemInfo.quantity}</Text>
                    <CustomPressable onPress={() => !isDisabled && handleAddToCart(cartItemInfo.itemInfo, cartItemInfo.addOns, true)} style={getStyles(['additem_controls_sub_container'])} id='additem_controls_sub_container'>
                        <ImageComp source={PLUS} style={getStyles(['additem_controls_sub_container_img'])} id='additem_controls_sub_container_img'/>
                    </CustomPressable>
                </View>
            </View>
        )
    }

    return (
        <ScrollView automaticallyAdjustKeyboardInsets={true} contentContainerStyle={getStyles(['widgetmainContainer', 'hcommerce_orderdetails_MainContainer'])} showsVerticalScrollIndicator={false} id='widgetmainContainer hcommerce_orderdetails_MainContainer'>

            {
                cartItem.length <= 0 ?

                    <View style={getStyles(['widgetmainContainerHeaderContainer', 'hcommerce_orderdetails_HeaderContainer'])} id='widgetmainContainerHeaderContainer hcommerce_orderdetails_HeaderContainer'>
                        {/* {
                            <ImageComp source={getCleanUrl(noItemImage)} style={getStyles(['widgetmainContainerHeaderImg', 'hcommerce_orderdetails_HeaderImg'])} />
                        } */}
                        <View style={getStyles(['widgetmainContainerHeaderTitleContainer', 'hcommerce_orderdetails_HeaderTitleContainer'])} id='widgetmainContainerHeaderTitleContainer hcommerce_orderdetails_HeaderTitleContainer'>
                            <Text style={getStyles(['widgetmainContainerHeaderTitle', 'hcommerce_orderdetails_HeaderTitle'])} id='widgetmainContainerHeaderTitle hcommerce_orderdetails_HeaderTitle'>{t('h-commerce.no_items')}</Text>
                            <CustomPressable style={getStyles(['secondaryBtn'])} onPress={() => handleGoBack()} id='secondaryBtn'>
                                <Text style={getStyles(['secondaryBtnTxt'])} id='secondaryBtnTxt'>{t('h-commerce.add_items')}</Text>
                            </CustomPressable>
                        </View>
                    </View>
                    :
                    <>

                        <View style={getStyles(['widgetmainContainerHeaderContainer', 'hcommerce_orderdetails_HeaderContainer'])} id='widgetmainContainerHeaderContainer hcommerce_orderdetails_HeaderContainer'>
                            <View style={getStyles(['widgetmainContainerHeaderTitleContainer', 'hcommerce_orderdetails_HeaderTitleContainer'])} id='widgetmainContainerHeaderTitleContainer hcommerce_orderdetails_HeaderTitleContainer'>
                                <Text style={getStyles(['widgetmainContainerHeaderTitle', 'hcommerce_orderdetails_HeaderTitle'])} id='widgetmainContainerHeaderTitle hcommerce_orderdetails_HeaderTitle'>{t('h-commerce.my_order')}</Text>
                                <Text style={getStyles(['widgetmainContainerHeaderSubTitle', 'hcommerce_orderdetails_HeaderSubTitle'])} id='widgetmainContainerHeaderSubTitle hcommerce_orderdetails_HeaderSubTitle'>{t('h-commerce.review_order')}</Text>
                            </View>

                            <View style={getStyles(['hcommerce_orderdetails_HeaderOrderDetailsContainer'])} id='hcommerce_orderdetails_HeaderOrderDetailsContainer'>
                                <CustomFlatList
                                    data={cartItem}
                                    nestedScrollEnabled={true}
                                    renderItem={({ item, index }) => renderOrderDetailsList(item, index)}
                                    keyExtractor={(item, index) => `${item.id}-${index}`}
                                    contentContainerStyle={getStyles(["hcommerce_orderdetails_HeaderOrderDetailsContentContainer"])}
                                    id="hcommerce_orderdetails_HeaderOrderDetailsContentContainer"
                                />
                            </View>
                        </View>

                        <View style={getStyles(['widgetmainContainerChildContainer', 'hcommerce_orderdetails_MainContainerChildContainer'])} id='widgetmainContainerChildContainer hcommerce_orderdetails_MainContainerChildContainer'>

                            <View style={getStyles(['hcommerce_orderdetails_MainContainerChildContainer_titlecontainer'])} id='hcommerce_orderdetails_MainContainerChildContainer_titlecontainer'>
                                <Text style={getStyles(['hcommerce_orderdetails_MainContainerChildContainer_title'])} id='hcommerce_orderdetails_MainContainerChildContainer_title'>{t('h-commerce.place_order')}</Text>
                                <Text style={getStyles(['hcommerce_orderdetails_MainContainerChildContainer_subtitle'])} id='hcommerce_orderdetails_MainContainerChildContainer_subtitle'>{t('h-commerce.confirm_details')}</Text>
                            </View>

                            {/* If not logged in as for email */}
                            {!isLoggedIn &&
                                <View style={getStyles(['textContainer'])} id='textContainer'>
                                    <Text style={getStyles(['label'])} id='label'>{t('h-commerce.email')} <Text style={getStyles(['requiredText'])}>*</Text></Text>
                                    <CustomTextInput
                                        placeholder="Enter your email address"
                                        value={orderDetails.email}
                                        onChangeText={(value) => handleOrderDetails({ "email": value })}
                                        autocomplete={"email"}
                                    />
                                </View>
                            }

                            {/* Delivery Locations */}
                            {(configs.displayAllDeliveryLocations || !isLoggedIn) &&
                                <CustomDropDown
                                    label="Delivery Location"
                                    isRequired={true}
                                    selectedOption={orderDetails.selectedLocation}
                                    isSearchable={true}
                                    onSelectOption={(value) => {
                                        const selectedRoom = configs.deliveryLocations.find(location => location.locationNumber === value.value);
                                        if (selectedRoom) selectRoom(selectedRoom);
                                    }}
                                    options={configs.deliveryLocations?.map(item => {
                                        return {
                                            value: item.locationNumber,
                                            label: item.locationNumber
                                        }
                                    })}
                                />
                            }

                            {/* Time Dropdown */}
                            {configs.displayDeliveyTime &&
                                <CustomDropDown
                                    label={t('h-commerce.time')}
                                    isRequired={true}
                                    selectedOption={orderDetails.selectedTime}
                                    onSelectOption={(value) => handleOrderDetails({ selectedTime: value.value })}
                                    options={storeDetails.orderTimeList?.map(item => {
                                        return {
                                            value: item.toString(),
                                            label: item.toString()
                                        }
                                    })}
                                />
                            }


                            {/* Guest Count Dropdown */}
                            {configs.guestCountEnabled &&
                                <CustomDropDown
                                    label={t('h-commerce.guest_Count')}
                                    isRequired={true}
                                    selectedOption={orderDetails.guestCount}
                                    onSelectOption={(value) => handleOrderDetails({ guestCount: value.value })}
                                    options={storeDetails.guestCountOptions?.map(item => {
                                        return {
                                            value: item.toString(),
                                            label: item.toString()
                                        }
                                    })}
                                />
                            }

                            <View style={getStyles(['textContainer'])} id='textContainer'>
                                <Text style={getStyles(['label'])} id='label'>{t('h-commerce.special_request_txt')}</Text>
                                <CustomTextInput
                                    style={{ height: 100 }}
                                    value={orderDetails.specialInstructions}
                                    onChangeText={(value) => handleOrderDetails({ "specialInstructions": value })}
                                    placeholder="Add any special instructions here"
                                    multiline
                                    numberOfLines={3}
                                />
                            </View>

                            {orderDetails.selectedLocation ?
                            <>

                                {/* Loading State */}
                                {pricingState.isLoading && (
                                    <View style={getStyles(['hcommerce_orderdetails_pricing_loader_container'])} id='hcommerce_orderdetails_pricing_loader_container'>
                                        <ActivityIndicator size="large" color={COLORS.PRIMARY_COLOR}/>
                                        <Text style={getStyles(['hcommerce_orderdetails_pricing_loader_text'])} id='hcommerce_orderdetails_pricing_loader_text'>
                                            Fetching pricing...
                                        </Text>
                                    </View>
                                )}

                                {/* Error State */}
                                {!pricingState.isLoading && pricingState.hasError && (
                                    <View style={getStyles(['hcommerce_orderdetails_pricing_error_container'])} id='hcommerce_orderdetails_pricing_error_container'>
                                        <Text style={getStyles(['hcommerce_orderdetails_pricing_error_text'])} id='hcommerce_orderdetails_pricing_error_text'>
                                            {pricingState.errorMessage || 'Unable to fetch pricing information'}
                                        </Text>
                                        <CustomPressable
                                            style={getStyles(['hcommerce_orderdetails_pricing_retry_btn'])}
                                            onPress={fetchToastPricing}
                                            id='hcommerce_orderdetails_pricing_retry_btn'
                                        >
                                            <Text style={getStyles(['hcommerce_orderdetails_pricing_retry_text'])} id='hcommerce_orderdetails_pricing_retry_text'>
                                                Retry
                                            </Text>
                                        </CustomPressable>
                                    </View>
                                )}

                                {!pricingState.isLoading && !pricingState.hasError && (
                                <View style={getStyles(['hcommerce_orderdetails_MainContainerChildContainer_pricelistcontainer'])} id='hcommerce_orderdetails_MainContainerChildContainer_pricelistcontainer'>

                                    {/* Display charges based on whether Toast is enabled */}
                                    {storeData.isPricingViaToast ? (
                                        <>
                                            {/* Toast Pricing Display */}
                                            {orderDetails.appliedServiceCharges && orderDetails.appliedServiceCharges.length > 0 &&
                                                orderDetails.appliedServiceCharges.map((charge, index) => (
                                                    <View key={index} style={getStyles(['hcommerce_orderdetails_MainContainerChildContainer_pricelistcontainer_text_container'])}
                                                        id='hcommerce_orderdetails_MainContainerChildContainer_pricelistcontainer_text_container'>
                                                        <Text style={getStyles(['hcommerce_orderdetails_MainContainerChildContainer_pricelistcontainer_text_container_text'])}
                                                            id='hcommerce_orderdetails_MainContainerChildContainer_pricelistcontainer_text_container_text'>
                                                            {charge.name}
                                                        </Text>
                                                        <Text style={getStyles(['hcommerce_orderdetails_MainContainerChildContainer_pricelistcontainer_text_container_price'])}
                                                            id='hcommerce_orderdetails_MainContainerChildContainer_pricelistcontainer_text_container_price'>
                                                            {currencyCode}{charge.chargeAmount.toFixed(precisionLength)}
                                                        </Text>
                                                    </View>
                                                ))
                                            }

                                            {orderDetails.taxAmountValue > 0 && (
                                                <View style={getStyles(['hcommerce_orderdetails_MainContainerChildContainer_pricelistcontainer_text_container'])}
                                                    id='hcommerce_orderdetails_MainContainerChildContainer_pricelistcontainer_text_container'>
                                                    <Text style={getStyles(['hcommerce_orderdetails_MainContainerChildContainer_pricelistcontainer_text_container_text'])}
                                                        id='hcommerce_orderdetails_MainContainerChildContainer_pricelistcontainer_text_container_text'>
                                                        {t('Tax')}
                                                    </Text>
                                                    <Text style={getStyles(['hcommerce_orderdetails_MainContainerChildContainer_pricelistcontainer_text_container_price'])}
                                                        id='hcommerce_orderdetails_MainContainerChildContainer_pricelistcontainer_text_container_price'>
                                                        {currencyCode}{orderDetails.taxAmountValue.toFixed(precisionLength)}
                                                    </Text>
                                                </View>
                                            )}
                                        </>
                                    ) : (
                                        <>
                                    {storeDetails.showDeliveryCharges &&
                                        <View style={getStyles(['hcommerce_orderdetails_MainContainerChildContainer_pricelistcontainer_text_container'])} id='hcommerce_orderdetails_MainContainerChildContainer_pricelistcontainer_text_container'>
                                            <Text style={getStyles(['hcommerce_orderdetails_MainContainerChildContainer_pricelistcontainer_text_container_text'])} id='hcommerce_orderdetails_MainContainerChildContainer_pricelistcontainer_text_container_text'>{t('h-commerce.delivery_Fee')} </Text>
                                            <Text style={getStyles(['hcommerce_orderdetails_MainContainerChildContainer_pricelistcontainer_text_container_price'])} id='hcommerce_orderdetails_MainContainerChildContainer_pricelistcontainer_text_container_price'>{`${currencyCode + orderDetails.deliveryChargeValue.toFixed(precisionLength)}`}</Text>
                                        </View>
                                    }
                                    <View style={getStyles(['hcommerce_orderdetails_MainContainerChildContainer_pricelistcontainer_text_container'])} id='hcommerce_orderdetails_MainContainerChildContainer_pricelistcontainer_text_container'>
                                        <Text style={getStyles(['hcommerce_orderdetails_MainContainerChildContainer_pricelistcontainer_text_container_text'])} id='hcommerce_orderdetails_MainContainerChildContainer_pricelistcontainer_text_container_text'>{t('h-commerce.sub_amount')}</Text>
                                        <Text style={getStyles(['hcommerce_orderdetails_MainContainerChildContainer_pricelistcontainer_text_container_price'])} id='hcommerce_orderdetails_MainContainerChildContainer_pricelistcontainer_text_container_price'>{`${currencyCode + orderDetails.subTotalAmountValue.toFixed(precisionLength)}`}</Text>
                                    </View>


                                    {storeDetails.serviceChargeEnabled &&
                                        <View style={getStyles(['hcommerce_orderdetails_MainContainerChildContainer_pricelistcontainer_text_container'])} id='hcommerce_orderdetails_MainContainerChildContainer_pricelistcontainer_text_container'>
                                            <Text style={getStyles(['hcommerce_orderdetails_MainContainerChildContainer_pricelistcontainer_text_container_text'])} id='hcommerce_orderdetails_MainContainerChildContainer_pricelistcontainer_text_container_text'>{`Service Charge (${storeDetails.serviceCharge}%)`}</Text>
                                            <Text style={getStyles(['hcommerce_orderdetails_MainContainerChildContainer_pricelistcontainer_text_container_price'])} id='hcommerce_orderdetails_MainContainerChildContainer_pricelistcontainer_text_container_price'>{`${currencyCode + orderDetails.serviceChargeAmountValue.toFixed(precisionLength)}`}</Text>
                                        </View>
                                    }

                                    {storeDetails.taxEnabled &&
                                        <View style={getStyles(['hcommerce_orderdetails_MainContainerChildContainer_pricelistcontainer_text_container'])} id='hcommerce_orderdetails_MainContainerChildContainer_pricelistcontainer_text_container'>
                                            <Text style={getStyles(['hcommerce_orderdetails_MainContainerChildContainer_pricelistcontainer_text_container_text'])} id='hcommerce_orderdetails_MainContainerChildContainer_pricelistcontainer_text_container_text'>{`Tax (${storeDetails.taxValue}%)`}</Text>
                                            <Text style={getStyles(['hcommerce_orderdetails_MainContainerChildContainer_pricelistcontainer_text_container_price'])} id='hcommerce_orderdetails_MainContainerChildContainer_pricelistcontainer_text_container_price'>{`${currencyCode + orderDetails.taxAmountValue.toFixed(precisionLength)}`}</Text>
                                        </View>
                                    }

                                    {storeDetails.showGratitudeSlider && (

                                        <View style={getStyles(['hcommerce_orderdetails_MainContainerChildContainer_pricelistcontainer_gratitude_top_container'])} id='hcommerce_orderdetails_MainContainerChildContainer_pricelistcontainer_gratitude_top_container'>

                                            <View style={getStyles(['hcommerce_orderdetails_MainContainerChildContainer_pricelistcontainer_text_container'])} id='hcommerce_orderdetails_MainContainerChildContainer_pricelistcontainer_text_container'>
                                                <Text style={getStyles(['hcommerce_orderdetails_MainContainerChildContainer_pricelistcontainer_text_container_text'])} id='hcommerce_orderdetails_MainContainerChildContainer_pricelistcontainer_text_container_text'>{t('h-commerce.gratitude')} ({`${orderDetails.gratitudePercentValue}`}%)</Text>
                                                <Text style={getStyles(['hcommerce_orderdetails_MainContainerChildContainer_pricelistcontainer_text_container_price'])} id='hcommerce_orderdetails_MainContainerChildContainer_pricelistcontainer_text_container_price'>{`${currencyCode + orderDetails.gratitudeAmountValue.toFixed(precisionLength)}`}</Text>
                                            </View>

                                            <View style={getStyles(['gratitude_container'])} id='gratitude_container'>
                                                <Slider
                                                    style={getStyles(['gratitude_Slider'])}
                                                    minimumValue={+storeDetails.gratitudeMin}
                                                    maximumValue={+storeDetails.gratitudeMax}
                                                    value={+orderDetails.gratitudePercentValue}
                                                    onValueChange={handleGratitudeSliderValue}
                                                    minimumTrackTintColor={COLORS.SECONDARY_COLOR}
                                                    maximumTrackTintColor="gray"
                                                    thumbTintColor={COLORS.SECONDARY_COLOR}
                                                    id='gratitude_Slider'
                                                />
                                                <View style={getStyles(['hcommerce_orderdetails_MainContainerChildContainer_pricelistcontainer_text_container'])} id='hcommerce_orderdetails_MainContainerChildContainer_pricelistcontainer_text_container'>
                                                    <Text style={getStyles(['hcommerce_orderdetails_MainContainerChildContainer_pricelistcontainer_text_container_text'])} id='hcommerce_orderdetails_MainContainerChildContainer_pricelistcontainer_text_container_text'>{`${storeDetails.gratitudeMin}`}%</Text>
                                                    <Text style={getStyles(['hcommerce_orderdetails_MainContainerChildContainer_pricelistcontainer_text_container_text'])} id='hcommerce_orderdetails_MainContainerChildContainer_pricelistcontainer_text_container_text'>{`${storeDetails.gratitudeMax}`}%</Text>
                                                </View>
                                            </View>
                                        </View>
                                            )}
                                        </>
                                    )}

                                    <View style={getStyles(['hcommerce_orderdetails_MainContainerChildContainer_pricelistcontainer_text_container', { marginTop: 16 }])} id='hcommerce_orderdetails_MainContainerChildContainer_pricelistcontainer_text_container'>
                                        <Text style={getStyles(['hcommerce_orderdetails_MainContainerChildContainer_pricelistcontainer_text_container_text'])} id='hcommerce_orderdetails_MainContainerChildContainer_pricelistcontainer_text_container_text'>{t('h-commerce.order_total')}</Text>
                                        <Text style={getStyles(['hcommerce_orderdetails_MainContainerChildContainer_pricelistcontainer_text_container_price'])} id='hcommerce_orderdetails_MainContainerChildContainer_pricelistcontainer_text_container_price'>{`${currencyCode + orderDetails.totalAmountValue.toFixed(precisionLength)}`}</Text>
                                    </View>

                                    {configs?.freeText && <View style={getStyles(['hcommerce_orderdetails_MainContainerChildContainer_pricelistcontainer_text_container'])} id='hcommerce_orderdetails_MainContainerChildContainer_pricelistcontainer_text_container'>
                                         <Text style={getStyles(['hcommerce_orderdetails_MainContainerChildContainer_pricelistcontainer_text_container_text'])} id='hcommerce_orderdetails_MainContainerChildContainer_pricelistcontainer_text_container_text'>
                                            {configs?.freeText}
                                         </Text>
                                    </View>}

                                </View>
                                )}
                            </>
                                :
                                <View style={getStyles(['hcommerce_orderdetails_MainContainerChildContainer_pricelistcontainer'])} id='hcommerce_orderdetails_MainContainerChildContainer_pricelistcontainer'>
                                    <View style={getStyles(['hcommerce_orderdetails_MainContainerChildContainer_pricelistcontainer_text_container'])} id='hcommerce_orderdetails_MainContainerChildContainer_pricelistcontainer_text_container'>
                                        <Text style={getStyles(['hcommerce_orderdetails_MainContainerChildContainer_pricelistcontainer_text_container_text'])} id='hcommerce_orderdetails_MainContainerChildContainer_pricelistcontainer_text_container_text'>{t('h-commerce.delivery_location')}</Text>
                                    </View>
                                </View>
                            }


                        </View>
                        <View style={getStyles(['hcommerce_orderdetails_MainContainerChildContainer_buttonContainer'])} id='hcommerce_orderdetails_MainContainerChildContainer_buttonContainer'>

                            <CustomPressable disabled={!orderDetails.selectedLocation || (storeData.isPricingViaToast && (pricingState.isLoading || pricingState.hasError))} onPress={proceedPlaceOrder} style={getStyles(['primaryBtn'])} id='primaryBtn'>
                                <Text style={getStyles(['primaryBtnTxt'])} id='primaryBtnTxt'>{t('h-commerce.place_order')}</Text>
                            </CustomPressable>

                            {/* <CustomPressable style={getStyles(['secondaryBtn'])} onPress={handleGoBack}>
                                <Text style={getStyles(['secondaryBtnTxt'])}>{t('h-commerce.back')}</Text>
                            </CustomPressable> */}
                        </View>
                    </>
            }
        </ScrollView >
    );
});

export default MyOrders;
